import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../common/SEO';
import GoogleMaps from '../components/GoogleMaps';
import ServicesNavigationFooter from '../components/ServicesNavigationFooter';

function Portfolio() {
  return (
    <div className="py-20">
      <SEO 
        title="Portfolio & Referenzen | MK-AUSBAU Heinsberg" 
        description="Sehen Sie sich unsere abgeschlossenen Projekte an. Bildergalerie unserer Arbeiten im Bereich Trockenbau, Boden, Dämmung und mehr."
        canonical="/portfolio"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Portfolio
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Entdecken Sie unsere neuesten Projekte und Arbeiten im Innenausbau. Lassen Sie sich von unserer Expertise und den realisierten Projekten inspirieren.
          </p>
        </motion.div>

        {/* Blog Widget */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mb-20"
        >
          <div className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
            {/* Elfsight Blog | MK Blog */}
            <div className="elfsight-app-5e257e0b-47f8-4fef-bfef-ddba67b2a89e w-full min-h-[600px]" data-elfsight-app-lazy></div>
          </div>
        </motion.div>

        {/* Photo Gallery Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Unsere Projekte in Bildern
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Sehen Sie sich unsere abgeschlossenen Projekte an und lassen Sie sich von der Qualität unserer Arbeit überzeugen.
            </p>
          </div>
          <div className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
            {/* Elfsight Photo Gallery | MK Gallery */}
            <div className="elfsight-app-4ae1f0b5-0b5b-422c-86eb-6fae3cf522bb w-full min-h-[600px]" data-elfsight-app-lazy></div>
          </div>
        </motion.div>
      </div>
      
      <ServicesNavigationFooter />
      <GoogleMaps />
    </div>
  );
}

export default Portfolio;